import {
  Component,
  inject,
  effect,
  ViewChild,
  output,
  input,
  OnInit,
  ViewChildren,
  QueryList,
  signal,
  computed,
  ChangeDetectionStrategy
} from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MasterDetailNav } from 'app/core/service/utils/master-detail-nav.service';
import Swal from 'sweetalert2';
import { forkJoin } from 'rxjs';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal, NgbModule, NgbModalRef, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { PartyOverviewService } from './party-overview.service';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID } from '@angular/core';
import { AuthService } from '@services/core/auth.service';
import { PermissionService } from '@services/core/permission.service';
import { AppSettings } from '@services/settings/app-settings.service';
import { CatalogService } from '@services/data/catalog.service';
import { SocketService } from '@services/core/socket.service';
import { filter } from 'rxjs/operators';
import { PartyFormComponent } from '../../components/party-form/party-form.component';
import { VehicleFormComponent } from '../../../management-vehicle/components/vehicle-form/vehicle-form.component';
import { PartyDocumentComponent } from '../../../management-document/components/party-document/party-document.component';
import { VehicleDocumentComponent } from '../../../management-document/components/vehicle-document/vehicle-document.component';
import { FormMode } from 'app/core/constants/form-mode';
import { AddVehicleComponent } from '../../../management-vehicle/pages/add-vehicle/add-vehicle.component';
import { RuleService } from '../../../management/rule-management/services/rule.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { PDFReportService } from '../../../../core/service/report/pdf/pdf-report-service';
import { AddClaimService } from '../../../management-claim/pages/add-claim/add-claim.service';
import { AddClaimComponent } from '../../../management-claim/pages/add-claim/add-claim.component';
import { AddPartyComponent } from '../add-party/add-party.component';
import { ViewerComponent } from '../../../management-document/components/viewer/viewer.component';
import { RequestUnsubscribeComponent } from '../../../management-request/components/request-unsubscribe/request-unsubscribe.component';
import { RequestTransferCreateComponent } from '../../../management-request/components/request-transfer-create/request-transfer-create.component';
import { AddBenefitComponent } from '../../../management-request/pages/add-benefit/add-benefit.component';
import { BpmService } from '../../../management-request/services/bpm.service';
import { Global } from '@services/core/Global';
import { ListCardComponent } from 'app/core/components/list-card/list-card.component';

@Component({
  selector: 'app-party-overview',
  templateUrl: './party-overview.component.html',
  styleUrls: ['./party-overview.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    VehicleFormComponent,
    PartyFormComponent,
    AddVehicleComponent,
    NgSelectModule,
    AddClaimComponent,
    AddPartyComponent,
    PartyDocumentComponent,
    VehicleDocumentComponent,
    ViewerComponent,
    RequestUnsubscribeComponent,
    RequestTransferCreateComponent,
    AddBenefitComponent,
    ListCardComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [PartyOverviewService, AddClaimService, { provide: LOCALE_ID, useValue: 'es-ES' }],
})
export class PartyOverviewComponent implements OnInit {
  public Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1000,
    timerProgressBar: true,
  });
  @ViewChild('preview') preview: any;
  @ViewChild('vehicleModal') vehicleModal: any;
  @ViewChild('addVehicleModal') addVehicleModal: any;
  @ViewChild(VehicleFormComponent) vehicleFormComponent!: VehicleFormComponent;
  data = input.required<any>();
  onClose = output<boolean>();
  onUpdate = output<void>();
  claimModeChange = output<boolean>();
  headerContextChange = output<{ title: string; showBack: boolean }>();
  @ViewChild(AddClaimComponent) addClaimComp?: AddClaimComponent;
  @ViewChild(AddPartyComponent) addPartyComp?: AddPartyComponent;
  private editorTitle = signal<string | null>(null);
  headerEditorAction = signal<'save' | 'finalize' | 'next' | null>(null);
  @ViewChildren(NgbPopover) popovers!: QueryList<NgbPopover>;
  public partyForm: FormGroup;
  public vehicleForm!: FormGroup; 
  public transferForm: FormGroup = new FormGroup({});
  /** Modo del modal de edición BPM: rápida (token) o completa (roles). */
  public vehicleEditMode: 'quick' | 'full' = 'full';
  /** Snapshot del vehículo al abrir el modal (from de proposedChanges). */
  private vehicleEditSnapshot: Record<string, any> | null = null;
  public showAddClaim = signal<boolean>(false);
  public showAddBenefit = signal<boolean>(false);
  public showBajaForm = signal<boolean>(false);
  public showTransferForm = signal<boolean>(false);
  public selectedBajaVehicleUuid = signal<string | null>(null);
  public unsubscribeScope = signal<'party' | 'admin'>('party');
  public showAddPartyView = signal<boolean>(false);
  public showAddVehicleView = signal<boolean>(false);
  public selectedClaimUuid = signal<string | null>(null);
  public bpmService = inject(BpmService);
  public selectedRequestParty: any = null;
  public selectedRequestVehicle: any = null;
  public selectedRequest: any = null;

  get thirdPartyBrands(): any[] {
    return this.catalogService.brands() ?? [];
  }

  get allModels(): any[] {
    return this.catalogService.models() ?? [];
  }
  private modalRef: NgbModalRef;
  public tabSelected = 1;
  private authService = inject(AuthService);
  readonly perm = inject(PermissionService);
  readonly appSettings = inject(AppSettings);
  private md = inject(MasterDetailNav);
  private socketService = inject(SocketService);
  public entity;
  public user;
  public isLoading = true;
  public vehicleData: any;
  public vehicleHistoryData: any;
  public statusData: any;
  public claimsData: any[] = [];
  public documentsData: any;
  public partyDocumentsData: any = null;
  public vehicleDocumentsData: any = null;
  public mode: FormMode = FormMode.VIEW;
  public formMode = FormMode;
  appHasAccess: string[] = [];
  public vehicleLimit: number = 2; // Default as fallback

  // Variables para el visor global de imágenes
  public isViewerOpen = false;
  public viewerItems: any[] = [];
  public activeViewerId: string | number = '';
  private ruleService = inject(RuleService);
  private catalogService = inject(CatalogService);
  private sanitizer = inject(DomSanitizer);
  private addClaimService = inject(AddClaimService);
  private http = inject(HttpClient);
  group = this.catalogService.groups;
  public pdfSrc: SafeResourceUrl | null = null;
  
  // Propiedades para Transferencia
  public transferEntities: any[] = [];
  public targetEntityCode: number | null = null;
  public transferReason: string = '';
  public transferVoto: string = '';
  public pendingTransfer = signal<any>(null);
  public recentRequests = signal<any[]>([]);
  public selectedProcess = undefined;
  public showViewUnsubscribe = signal<boolean>(false);
  public selectedUnsubscribeToken = signal<string | null>(null);
  public selectedBajaRequest = signal<any>(null);
  public isDraft = computed(() => {
    return String(this.data()?.statusSlug ?? '').toUpperCase() === 'DRAFT';
  });
  public isActive = computed(() => {
    return String(this.data()?.statusSlug ?? '').toUpperCase() === 'ACTIVE';
  });

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private partyOverviewService: PartyOverviewService
  ) {
    effect(() => {
      this.entity = this.authService.sharingEntity();
      this.user = this.authService.userData();
      if (this.entity && Object.keys(this.entity).length > 0) {
      }
    });

    // React to data input changes
    effect(() => {
      const partyData = this.data();

      if (partyData && this.partyForm) {
        this.partyForm.patchValue({
          uuid: partyData.uuid,
          rut: partyData.rut,
          partyTypeSlug: partyData.partyTypeSlug,
          names: partyData.names,
          birthday: partyData.birthday,
          mail: partyData.mail,
          mobileNumber: partyData.mobileNumber,
          statusSlug: partyData.statusSlug,
          groupSlug: partyData.groupSlug,
          entityCode: partyData.entityCode,
        });

        // Usar los datos que ya vienen de la API en lugar de hacer llamadas extra
        this.processExpandedData(partyData);
        this.getDocumentView(partyData.uuid);
        this.checkPendingTransfer(partyData.uuid);
        this.loadRecentRequests(partyData.uuid);
      }
    });

    this.md.urlChanges$.pipe(takeUntilDestroyed()).subscribe(() => this.syncFromRoute());

    this.socketService.onCatalogChanged().pipe(
      filter((ev) => this.shouldRefreshDocsFromCatalog(ev)),
      takeUntilDestroyed()
    ).subscribe(() => this.refreshDocuments());

    this.socketService.onNotification().pipe(
      filter((notice) => this.shouldRefreshFromNotice(notice)),
      takeUntilDestroyed()
    ).subscribe(() => this.handleSocketRefresh());
  }

  // Evalua si la notificacion corresponde a una actualizacion de solicitud o socio
  private shouldRefreshFromNotice(notice: any): boolean {
    const type = String(notice?.type ?? notice?.data?.type ?? '');
    return type === 'REQUEST_UPDATE' || type === 'PARTY_UPDATED' || type === 'PERIOD_UPDATED';
  }

  // Refresca datos de socio y solicitudes al recibir evento socket
  private handleSocketRefresh(): void {
    this.onUpdate.emit();
    const uuid = this.data()?.uuid;
    if (uuid) this.loadRecentRequests(uuid);
  }

  /** Recarga documents-view (slots de la solicitud), no el catálogo vivo. */
  private shouldRefreshDocsFromCatalog(ev: { scopes?: string[]; applyToOpen?: boolean } | null): boolean {
    if (!ev || ev.applyToOpen !== true) return false;
    const scopes = (ev.scopes ?? []).map((s) => String(s).toLowerCase());
    const hit = !scopes.length
      || scopes.includes('all')
      || scopes.includes('documentrequirements')
      || scopes.includes('document-requirements');
    return hit && !!this.data()?.uuid;
  }


  /*abre los modales */
  open(content, size: 'md' | 'lg' | 'xl' = 'lg') {
    this.modalRef = this.modalService.open(content, { size: size });
  }

  tabChange(tab) {
    this.tabSelected = tab.id;
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }


  createForm() {
    this.partyForm = this.formBuilder.group({
      uuid: [null],
      rut: [null, [Validators.required]],
      partyTypeSlug: ['NATURAL', [Validators.required]],
      names: [null, [Validators.required]],
      birthday: [null],
      mail: [null],
      mobileNumber: [null],
      groupSlug: [null],
      entityCode: [null]
    });

    this.transferForm = this.formBuilder.group({
      targetEntityCode: [null],
      processSlug: [null],
      referenceUuid: [null],
      reason: [null]
    });
  }

  createVehicleForm() {
    this.vehicleForm = this.formBuilder.group({
      uuid: [null],
      partyUuid: [null, [Validators.required]],
      plate: [null, [Validators.required]],
      brandCode: [null, [Validators.required]],
      color: [null],
      colorCode: [null],
      modelCode: [null, [Validators.required]],
      year: [null, [Validators.required]],
      vin: [null, [Validators.required]],
      km: [null],
      vehicleType: [null],
      commercialValue: [null, [Validators.required]],
      value: [null, [Validators.required]],
      statusSlug: [null],
      isTransmissionAutomatic: [false]
    });
  }

  ngOnInit(): void {
    this.createForm();
    this.createVehicleForm();
    this.catalogService.loadCatalogs();

    // Obtener configuración de límite de vehículos
    this.ruleService.get().subscribe({
      next: (rules: any[]) => {
        const membershipRule = rules.find(r => r.slug === 'MEMBERSHIP_QTY' && r.isActive);
        if (membershipRule && membershipRule.value) {
          this.vehicleLimit = parseInt(membershipRule.value, 10);
        }
      },
      error: (err) => console.error('Error al cargar config de Reglas', err)
    });

    if (this.data()) {
      const partyData = this.data();
      this.partyForm.patchValue({
        uuid: partyData.uuid,
        rut: partyData.rut,
        partyTypeSlug: partyData.partyTypeSlug,
        names: partyData.names,
        birthday: partyData.birthday,
        mail: partyData.mail,
        mobileNumber: partyData.mobileNumber,
        statusSlug: partyData.statusSlug,
        groupSlug: partyData.groupSlug,
        entityCode: partyData.entityCode,
      });
      this.processExpandedData(partyData);
      this.getDocumentView(partyData.uuid);
      this.checkPendingTransfer(partyData.uuid);
      this.loadRecentRequests(partyData.uuid);
    }
  }


  checkPendingTransfer(uuid: string) {
    if (!uuid) return;
    this.partyOverviewService.getRequest({ partyUuid: uuid, processSlug: 'TRANSFER' }).subscribe((res: any) => {
        const list = Array.isArray(res) ? res : (res.data || []);
        const pending = list.find((r: any) =>
          r.party?.uuid == uuid
          && String(r.statusSlug || '').toUpperCase() !== 'REJECTED'
          && this.bpmService.isFlowOpen(r)
        );
        this.pendingTransfer.set(pending || null);
    });
  }

  loadRecentRequests(uuid: string) {
    if (!uuid) return;
    this.partyOverviewService.getPartyRequests(uuid).subscribe({
      next: (res: any) => {
        const list = Array.isArray(res) ? res : (res?.data ?? []);
        this.recentRequests.set(list.slice(0, 5));
      },
      error: (err) => console.error('Error al cargar solicitudes recientes', err)
    });
  }

  private docsLoadSeq = 0;

  getDocumentView(uuid) {
    if (!uuid) return;
    const seq = ++this.docsLoadSeq;
    // Evitar mostrar docs del socio anterior mientras carga
    this.documentsData = null;
    this.partyDocumentsData = null;
    this.vehicleDocumentsData = null;

    this.partyOverviewService.getDocumentView({ partyUuid: uuid }).subscribe({
      next: (res: any) => {
        if (seq !== this.docsLoadSeq) return;
        const allDocs = res[0] ?? res;
        this.documentsData = allDocs;
        if (allDocs?.categories) {
          this.partyDocumentsData = this._extractCategories(allDocs, ['PARTY', 'MEMBER']);
          this.vehicleDocumentsData = this._extractCategories(allDocs, ['VEHICLE']);
        } else {
          this.partyDocumentsData = allDocs;
          this.vehicleDocumentsData = allDocs;
        }
      },
      error: () => {
        if (seq !== this.docsLoadSeq) return;
        this.documentsData = null;
        this.partyDocumentsData = null;
        this.vehicleDocumentsData = null;
      }
    });
  }

  _extractCategories(allDocs: any, ownerSlugs: string[]) {
    const allowed = new Set(ownerSlugs.map((s) => String(s).toUpperCase()));
    const categories = allDocs.categories.map((cat: any) => {
      const docs = (cat.documents || []).filter((d: any) =>
        allowed.has(String(d.ownerSlug || '').toUpperCase()) && this.isOverviewDocument(d)
      );
      return { ...cat, documents: docs };
    }).filter((cat: any) => cat.documents.length > 0);
    return { ...allDocs, categories };
  }

  /**
   * Overview: MEMBERSHIP_NEW / VEHICLE_NEW (ficha) + DOC_RENEWAL solo APPROVED.
   * PARTY → bloque socio; VEHICLE → bloque vehículo (vía _extractCategories).
   * Nunca vencidos (EXPIRED o expirationDate pasada). Sin THIRD_PARTY ni siniestros.
   */
  private isOverviewDocument(doc: any): boolean {
    if (String(doc?.statusSlug || '').toUpperCase() === 'EXPIRED') return false;
    const exp = doc?.expirationDate;
    if (exp) {
      const today = new Date().toISOString().slice(0, 10);
      if (String(exp).slice(0, 10) < today) return false;
    }

    const slug = String(doc?.processSlug || '').toUpperCase();
    if (slug === 'MEMBERSHIP_NEW' || slug === 'VEHICLE_NEW') return true;
    if (slug === 'DOC_RENEWAL') {
      return String(doc?.statusSlug || '').toUpperCase() === 'APPROVED';
    }
    return false;
  }

  processExpandedData(partyData: any) {
    this.claimsData = [];
    if (!partyData?.vehicles?.length) {
      this.vehicleHistoryData = [];
      this.vehicleData = [];
      return;
    }
    const mappedVehicles = partyData.vehicles.map(v => this._mapVehicle(v, partyData.uuid));
    this.vehicleHistoryData = JSON.parse(JSON.stringify(mappedVehicles));
    this.vehicleData = mappedVehicles.filter((d) => {
      const slug = String(d.statusSlug || '').toUpperCase();
      return slug === 'ACTIVE' || slug === 'DRAFT' || d.statusIsActive;
    });
    this.claimsData.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  }

  private _mapVehicle(v: any, partyUuid: string) {
    if (v.claims) {
      const claimsWithPlate = v.claims.map((c: any) => ({ ...c, plate: v.plate }));
      this.claimsData.push(...claimsWithPlate);
    }
    return {
      ...v, partyUuid,
      brandName: v.brand?.name, colorName: v.color?.name,
      modelName: v.model?.name, modelType: v.model?.vehicleType,
      statusName: v.status?.name, statusIsActive: v.status?.isActive
    };
  }

  openModal(vehicle, editMode: 'quick' | 'full' = 'full') {
    if (String(vehicle?.statusSlug || '').toUpperCase() !== 'ACTIVE') {
      this.Toast.fire({ icon: 'warning', title: 'Solo se pueden editar vehículos activos' });
      return;
    }
    this._openVehicleEditModal(vehicle, editMode);
  }

  private _openVehicleEditModal(vehicle: any, editMode: 'quick' | 'full') {
    this.vehicleEditMode = editMode;
    this.vehicleForm.reset();
    const data = {
      ...vehicle,
      vehicleType: vehicle.modelType,
      color: vehicle.color ?? vehicle.colorName ?? vehicle.colorCode ?? null,
      partyUuid: vehicle.partyUuid || this.data()?.uuid
    };
    this.vehicleEditSnapshot = {
      plate: data.plate ?? null,
      year: data.year ?? null,
      brandCode: data.brandCode ?? null,
      modelCode: data.modelCode ?? null,
      vin: data.vin ?? null,
      value: data.value ?? null,
      commercialValue: data.commercialValue ?? null,
      color: data.color ?? null,
      km: data.km ?? null
    };
    this.vehicleForm.patchValue(data);
    this.open(this.vehicleModal);
  }

  private cleanNum(value: any): any {
    if (typeof value === 'string' && value.length > 0) {
      return value.replace(/\./g, '').replace(',', '.');
    }
    return value;
  }

  private buildProposedChanges(formValue: any): Record<string, { from: any; to: any }> | null {
    const quickFields = ['plate', 'commercialValue', 'color', 'km'];
    const sensitiveFields = ['year', 'value', 'vin', 'brandCode', 'modelCode'];
    const fields = this.vehicleEditMode === 'quick'
      ? quickFields
      : [...quickFields, ...sensitiveFields];
    const from = this.vehicleEditSnapshot || {};
    const out: Record<string, { from: any; to: any }> = {};
    for (const key of fields) {
      let toVal = formValue?.[key];
      let fromVal = from[key];
      if (key === 'commercialValue' || key === 'value' || key === 'km') {
        toVal = this.cleanNum(toVal);
        fromVal = this.cleanNum(fromVal);
      }
      if (toVal === undefined || toVal === null || toVal === '') continue;
      const toCmp = toVal != null ? String(toVal) : '';
      const fromCmp = fromVal != null ? String(fromVal) : '';
      if (toCmp === fromCmp) continue;
      out[key] = { from: fromVal ?? null, to: toVal };
    }
    return Object.keys(out).length ? out : null;
  }

  onVehicleSubmit(form: FormGroup) {
    // Incluye disabled (sensibles en quick) para validar el form completo.
    const raw = form.getRawValue();
    if (form.invalid) {
      console.warn('Formulario inválido', this.collectInvalidControls(form));
      this.Toast.fire({
        icon: 'warning',
        title: 'Formulario inválido, revise los campos requeridos'
      });
      return;
    }
    const proposedChanges = this.buildProposedChanges(raw);
    if (!proposedChanges) {
      this.Toast.fire({ icon: 'info', title: 'No hay cambios para enviar' });
      return;
    }
    const processSlug = this.vehicleEditMode === 'quick'
      ? 'VEHICLE_QUICK_UPDATE'
      : 'VEHICLE_DATA_UPDATE';
    const payload = {
      partyUuid: this.data()?.uuid,
      processSlug,
      entityCode: this.data()?.entityCode ?? this.entity?.code,
      referenceUuid: raw.uuid,
      reason: this.vehicleEditMode === 'quick'
        ? 'Actualización rápida de vehículo'
        : 'Actualización de datos de vehículo',
      proposedChanges
    };
    this.partyOverviewService.createTransferRequest(payload).subscribe({
      next: () => {
        this.Toast.fire({
          icon: 'success',
          title: this.vehicleEditMode === 'quick'
            ? 'Solicitud enviada; el socio debe confirmar'
            : 'Solicitud enviada a revisión'
        });
        this.close();
        this.onUpdate.emit();
      },
      error: (err) => {
        console.error(err);
        this.Toast.fire({
          icon: 'error',
          title: err?.error?.message || err?.message || 'Error al crear la solicitud'
        });
      }
    });
  }

  collectInvalidControls(form: FormGroup): any[] {
    const invalid = [];
    const controls = form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }


  submitVehicleForm() {
    this.onVehicleSubmit(this.vehicleForm);
  }

  submitParty() {
    if (this.partyForm?.valid) {
      this.mode = this.formMode.VIEW;
      this.partyOverviewService.updateParty(this.partyForm.value).subscribe((res: any) => {
        this.Toast.fire({
          icon: 'success',
          title: 'Socio actualizado correctamente',
        });
        this.onUpdate.emit();
      })
    } else {
      this.partyForm.markAllAsTouched();
      console.warn('Formulario no inicializado o inválido', this.collectInvalidControls(this.partyForm));
      this.Toast.fire({
          icon: 'warning',
          title: 'Formulario inválido. Revisa los campos marcados.'
      });
    }
  }

  updateStatus(params, statusSlug) {
    Swal.fire({
      icon: 'warning',
      title: 'Alerta ',
      text: '¿Desea ' + (statusSlug == 'INACTIVE' ? 'desactivar' : 'activar') + ' ' + params.names + '?',
      toast: false,
      position: 'center',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.partyOverviewService.updateParty({ uuid: params.uuid, statusSlug: statusSlug }).subscribe(
          (res: any) => {
            this.data().statusSlug = statusSlug;
            this.Toast.fire({
              icon: 'success',
              title: 'Socio ' + (statusSlug == 'INACTIVE' ? 'desactivado' : 'activado') + ' correctamente',
            });
            this.onUpdate.emit();
            this.close();
          })

      }
    })
  }

  onModeChange(newMode: FormMode) {
    this.mode = newMode;
  }

  openAddVehicleModal() {
    if (this.vehicleData && this.vehicleData.length >= this.vehicleLimit) {
      Swal.fire({
        icon: 'warning',
        title: 'Límite de Vehículos',
        text: `Este socio ya ha alcanzado el máximo de ${this.vehicleLimit} vehículos activos permitidos por configuración.`,
        confirmButtonText: 'Entendido'
      });
      return;
    }

    this.showAddVehicleView.set(true);
  }

  // Abre la vista para registrar siniestro
  openAddClaimModal() {
    if (!this.perm.hasCurrentAction('CLAIM_CREATE') && !this.perm.canCurrent('canUpdate')) return;
    const partyUuid = this.data()?.uuid;
    if (partyUuid) this.md.go(this.md.claim(partyUuid));
  }

  onEditorTitle(title: string | null) {
    this.editorTitle.set(title);
    this.emitHeaderContext();
  }

  onHeaderEditorAction(action: 'save' | 'finalize' | 'next' | null) {
    this.headerEditorAction.set(action);
  }

  closeAddClaim() {
    const partyUuid = this.data()?.uuid;
    this.md.go(partyUuid ? this.md.party(partyUuid) : this.md.parties());
  }

  private syncFromRoute() {
    const st = this.md.parse();
    if (st.area !== 'socios') return;
    const onClaim = st.view === 'siniestro';
    const onBenefit = st.view === 'beneficio';
    const onIncorp = st.view === 'incorporacion';
    const onTransfer = st.view === 'transferencia';
    const onBaja = st.view === 'baja';
    this.showAddClaim.set(onClaim);
    this.showAddBenefit.set(onBenefit);
    this.showAddPartyView.set(onIncorp);
    this.showTransferForm.set(onTransfer);
    this.showBajaForm.set(onBaja);
    if (onTransfer) {
      this.selectedProcess = this.selectedProcess || 'TRANSFER';
    }
    if (onBaja) {
      this.selectedProcess = this.selectedProcess || 'UNSUBSCRIBE_VOLUNTARY';
      this.showViewUnsubscribe.set(false);
      this.selectedBajaRequest.set(null);
    }
    if (!onIncorp) {
      this.selectedRequest = null;
      this.selectedRequestParty = null;
      this.selectedRequestVehicle = null;
    }
    this.selectedClaimUuid.set(onClaim && st.claimUuid && st.claimUuid !== 'nuevo' ? st.claimUuid : null);
    if (!onClaim && !onIncorp) {
      this.headerEditorAction.set(null);
      this.editorTitle.set(null);
    }
    // Siniestro / incorporación no ocultan el master en escritorio: quedan en col-md-9.
    // En móvil el master ya se oculta por partyOut seleccionado.
    this.claimModeChange.emit(onBenefit || onTransfer || onBaja || this.showViewUnsubscribe());
    this.emitHeaderContext();
  }

  currentHeaderAction(): 'save' | 'finalize' | 'next' | null {
    if (this.showAddPartyView()) {
      return this.addPartyComp?.headerEditorAction() ?? null;
    }
    if (this.showAddClaim()) {
      return this.addClaimComp?.headerWizardAction() ?? this.headerEditorAction();
    }
    return null;
  }

  saveEditorFromHeader() {
    if (this.showAddPartyView()) {
      this.addPartyComp?.saveEditorFromHeader();
      return;
    }
    this.addClaimComp?.saveEditorFromHeader();
  }

  isEditorSaving(): boolean {
    if (this.showAddPartyView()) {
      return !!this.addPartyComp?.isEditorSaving();
    }
    return !!this.addClaimComp?.isEditorSaving();
  }

  canFinalizeFromHeader(): boolean {
    return this.currentHeaderAction() === 'finalize';
  }

  canDeleteFromHeader(): boolean {
    if (this.showAddPartyView()) {
      return !!this.addPartyComp?.canDeleteFromHeader();
    }
    return !!this.addClaimComp?.canDeleteFromHeader();
  }

  deleteFromHeader() {
    if (this.showAddPartyView()) {
      this.addPartyComp?.deleteFromHeader();
      return;
    }
    this.addClaimComp?.deleteFromHeader();
  }

  closeFromHeader() {
    this.md.back(this.data()?.uuid ? this.md.party(this.data().uuid) : this.md.parties());
  }

  closeAddPartyView() {
    const partyUuid = this.data()?.uuid;
    this.md.go(partyUuid ? this.md.party(partyUuid) : this.md.parties());
    this.onUpdate.emit();
    if (partyUuid) {
      this.loadRecentRequests(partyUuid);
      this.getDocumentView(partyUuid);
    }
  }

  private emitHeaderContext() {
    if (this.showAddClaim()) {
      this.headerContextChange.emit({
        title: this.editorTitle() ?? 'Siniestro',
        showBack: true
      });
      return;
    }
    if (this.showAddPartyView()) {
      this.headerContextChange.emit({ title: 'Incorporación', showBack: true });
      return;
    }
    if (this.showAddBenefit()) {
      this.headerContextChange.emit({ title: 'Beneficio', showBack: true });
      return;
    }
    if (this.showTransferForm()) {
      this.headerContextChange.emit({ title: 'Transferencia', showBack: true });
      return;
    }
    if (this.showBajaForm() || this.showViewUnsubscribe()) {
      this.headerContextChange.emit({ title: 'Baja', showBack: true });
      return;
    }
    this.headerContextChange.emit({ title: 'Socios', showBack: false });
  }

  // Abre la vista para asociar un beneficio
  openAddBenefitModal() {
    if (!this.perm.hasCurrentAction('BENEFIT_CREATE') && !this.perm.canCurrent('canUpdate')) return;
    if (!(this.vehicleData?.length ?? 0)) {
      Swal.fire({ icon: 'warning', title: 'Sin vehículos', text: 'Este socio no tiene vehículos para asociar un beneficio.', confirmButtonText: 'Entendido' });
      return;
    }
    this.md.go(this.md.benefit(this.data()?.uuid));
  }

  onBenefitAdded() {
    this.closeAddBenefit();
    this.onUpdate.emit();
    if (this.data()?.uuid) this.loadRecentRequests(this.data().uuid);
  }

  closeAddBenefit() {
    const partyUuid = this.data()?.uuid;
    this.md.go(partyUuid ? this.md.party(partyUuid) : this.md.parties());
  }

  openRecentRequest(req: any): void {
    const slug = req?.processSlug;
    if (slug === 'ACCIDENT' || slug === 'ACCIDENT_THIRD_PARTY' || slug === 'TOTAL_LOSS') {
      this.viewClaimFromRequest(req);
      return;
    }
    if (slug === 'BENEFITS' || slug === 'BENEFIT') {
      this.viewBenefitFromRequest(req);
      return;
    }
    if (slug === 'MEMBERSHIP_NEW') {
      this.viewMembershipFromRequest(req);
      return;
    }
    if (slug === 'TRANSFER') {
      this.viewTransferFromRequest(req);
      return;
    }
    if (this.bpmService.isUnsubscribeProcess(slug) || slug === 'UNSUBSCRIBE') {
      this.viewUnsubscribeFromRequest(req);
    }
  }

  viewBenefitFromRequest(req: any) {
    if (!req?.uuid) return;
    this.md.go(this.md.request(req.uuid));
  }

  viewClaimFromRequest(req: any) {
    if (!req || !req.uuid) return;
    if (req.statusSlug === 'DRAFT' && req.claim?.uuid) {
      this.md.go(this.md.claim(this.data().uuid, req.claim.uuid));
    } else {
      this.md.go(this.md.request(req.uuid));
    }
  }

  viewMembershipFromRequest(req: any) {
    if (!req) return;
    if (req.statusSlug === 'DRAFT') {
      this.selectedRequest = req;
      this.selectedRequestParty = this.data() || req.party;
      const realVehicle = (this.vehicleData && this.vehicleData.length > 0) ? this.vehicleData[0] : null;
      this.selectedRequestVehicle = realVehicle;
      this.md.go(this.md.membership(this.data().uuid));
      return;
    }
    this.md.go(this.md.request(req.uuid));
  }

  onVehicleAdded() {
    this.onUpdate.emit();
  }

  onClaimAdded() {
    this.closeAddClaim();
    this.onUpdate.emit();
    if (this.data()?.uuid) {
      this.loadRecentRequests(this.data().uuid);
    }
  }

  // Refrescar documentos después de actualización
  refreshDocuments() {
    if (this.data()?.uuid) {
      this.getDocumentView(this.data().uuid);
    }
  }

  getEntityName(code: number | string): string {
    if (!code) return 'N/A';
    const entity = this.catalogService.entities().find(e => e.code == code);
    return entity ? `${entity.name}` : `Entidad ${code}`;
  }

  getProcessName(slug: string): string {
    if (!slug) return 'Gestión de Solicitud';
    const process = this.catalogService.processes().find(p => p.slug == slug);
    return process ? process.name : 'Solicitud Genérica';
  }

  viewTransferFromRequest(req: any): void {
    if (!req?.uuid) return;
    this.md.go(this.md.request(req.uuid));
  }

  viewUnsubscribeFromRequest(req: any): void {
    if (!req) return;
    this.selectedBajaRequest.set(req);
    this.selectedUnsubscribeToken.set(req.confirmationToken || null);
    this.showViewUnsubscribe.set(true);
    this.claimModeChange.emit(true);
    this.emitHeaderContext();
  }



  deleteUnsubscribeRequest(req: any): void {
    if (!req || !req.uuid) return;
    Swal.fire({
      title: '¿Desechar solicitud de baja?',
      text: 'Quedará como Desechada en el historial y podrá reactivarse después.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, desechar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33'
    }).then(res => {
      if (res.isConfirmed) {
        this.http.post<any>(`${Global.url}V1/requests/${req.uuid}/discard`, {}).subscribe({
          next: () => {
            Swal.fire('Desechada', 'La solicitud quedó en el historial como Desechada.', 'success');
            if (this.data()?.uuid) {
              this.loadRecentRequests(this.data().uuid);
            }
          },
          error: (err) => {
            Swal.fire('Error', err.error?.error || err.error?.message || 'No se pudo desechar la solicitud', 'error');
          }
        });
      }
    });
  }

  openUnsubscribeParty(referenceUuid?: string): void {
    this.unsubscribeScope.set('party');
    this.openRequestModal('UNSUBSCRIBE_VOLUNTARY', referenceUuid);
  }

  openUnsubscribeAdmin(referenceUuid?: string): void {
    this.unsubscribeScope.set('admin');
    this.openRequestModal('UNSUBSCRIBE_CESE_LABORAL', referenceUuid);
  }

  openVehicleFullFromHeader(): void {
    const active = (this.vehicleData || []).filter(
      (v: any) => String(v?.statusSlug || '').toUpperCase() === 'ACTIVE'
    );
    if (!active.length) {
      this.Toast.fire({ icon: 'warning', title: 'Sin vehículos activos para modificar' });
      return;
    }
    this.openModal(active[0], 'full');
  }

  openRequestModal(processSlug: string, referenceUuid?: string) {
    this.selectedProcess = processSlug;
    if (this.bpmService.isTransferProcess(processSlug) && this._checkPendingTransfer()) return;
    if (this.bpmService.isUnsubscribeProcess(processSlug) && !this.vehicleData?.length) {
      Swal.fire({
        icon: 'warning',
        title: 'Sin vehículos',
        text: 'El socio no tiene vehículos activos para iniciar una solicitud de baja.',
        confirmButtonText: 'Entendido'
      });
      return;
    }
    this.transferForm.reset();
    this.transferForm.get('processSlug')?.setValue(processSlug);
    if (referenceUuid) {
      this.selectedBajaVehicleUuid.set(referenceUuid);
      this.transferForm.get('referenceUuid')?.setValue(referenceUuid);
    } else if (this.bpmService.isUnsubscribeProcess(processSlug) && this.vehicleData?.length === 1) {
      const onlyUuid = this.vehicleData[0]?.uuid;
      this.selectedBajaVehicleUuid.set(onlyUuid ?? null);
      if (onlyUuid) this.transferForm.get('referenceUuid')?.setValue(onlyUuid);
    } else {
      this.selectedBajaVehicleUuid.set(null);
    }
    this._applyRequestValidators(processSlug);
    this._openRequestFlow(processSlug);
  }

  private _checkPendingTransfer(): boolean {
    const trans = this.pendingTransfer();
    if (!trans) return false;
    Swal.fire({
      title: 'Transferencia en Trámite',
      html: `Existe una solicitud pendiente hacia a la <b>${this.getEntityName(trans.targetEntityCode)}</b>.<br><br><b>Estado:</b> ${trans.statusObj.name}<br>`,
      icon: 'info',
      confirmButtonText: 'Entendido'
    });
    return true;
  }

  private _applyRequestValidators(processSlug: string) {
    const isTrans = this.bpmService.isTransferProcess(processSlug);
    const controls = {
      targetEntityCode: this.transferForm.get('targetEntityCode'),
      reason: this.transferForm.get('reason')
    };
    controls.targetEntityCode?.setValidators(isTrans ? [Validators.required] : null);
    controls.reason?.setValidators(isTrans ? null : [Validators.required]);
    Object.values(controls).forEach(c => c?.updateValueAndValidity());
  }

  private _openRequestFlow(processSlug: string) {
    if (this.bpmService.isTransferProcess(processSlug)) {
      const uuid = this.data()?.uuid;
      if (!uuid) return;
      this.md.go(this.md.transfer(uuid));
      return;
    }
    if (this.bpmService.isUnsubscribeProcess(processSlug)) {
      const uuid = this.data()?.uuid;
      if (!uuid) return;
      this.showViewUnsubscribe.set(false);
      this.selectedBajaRequest.set(null);
      this.md.go(this.md.baja(uuid));
    }
  }

  closeBajaForm(): void {
    const partyUuid = this.data()?.uuid;
    this.showBajaForm.set(false);
    this.showViewUnsubscribe.set(false);
    this.selectedBajaRequest.set(null);
    this.claimModeChange.emit(false);
    this.emitHeaderContext();
    this.md.go(partyUuid ? this.md.party(partyUuid) : this.md.parties());
  }

  onBajaSubmitted(): void {
    const uuid = this.data()?.uuid;
    if (uuid) {
      this.checkPendingTransfer(uuid);
      this.loadRecentRequests(uuid);
    }
    this.onUpdate.emit();
    this.closeBajaForm();
  }

  closeTransferForm(): void {
    const partyUuid = this.data()?.uuid;
    this.md.go(partyUuid ? this.md.party(partyUuid) : this.md.parties());
  }

  onTransferSubmitted(): void {
    const uuid = this.data()?.uuid;
    if (uuid) {
      this.checkPendingTransfer(uuid);
      this.loadRecentRequests(uuid);
    }
    this.closeTransferForm();
  }

  // --- MÉTODOS REPORTE PDF (Estilo Billing) ---

  getDate() {
    let date = new Date();
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' } as const;
    return date.toLocaleDateString('es-ES', options) + ' ' + date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  }

  getDomain() {
    return window.location.hostname.split('.')[0] + '.uch';
  }

  getCurrentDateFormatted() {
    return new Date().toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  getSelectedVehicle() {
    const uuid = this.transferForm.get('referenceUuid')?.value;
    return this.vehicleData?.find(v => v.uuid === uuid || v.id === uuid);
  }


  private addHeaderPDF(doc: jsPDF, entityName: string, title: string = 'SOLICITUD DE TRÁMITE', periodName: string = ''): number {
    let currentY = 35;
    // Encabezado 1: Entidad
    autoTable(doc, {
      startY: currentY,
      head: [
        [{ content: 'Fondo de Protección Vehicular', styles: { fontStyle: 'normal', fontSize: 10 } }],
        [{ content: entityName, styles: { fontStyle: 'italic', fontSize: 10 } }]
      ],
      theme: 'plain',
      headStyles: { halign: 'center', cellPadding: 1, textColor: [0, 0, 0] },
      margin: { left: 0, right: 0 },
      tableWidth: 'auto',
      didDrawPage: (data) => { currentY = data.cursor?.y || currentY; }
    });

    const header2Body = [[{ content: title, styles: { fontStyle: 'bold' as const, fontSize: 11 } }]];
    if (periodName) {
        header2Body.push([{ content: `Periodo: ${periodName}`, styles: { fontStyle: 'bold' as const, fontSize: 9 } }]);
    }

    // Encabezado 2: Título
    autoTable(doc, {
      startY: currentY + 10,
      head: header2Body,
      theme: 'plain',
      headStyles: { halign: 'center', cellPadding: 0.3, textColor: [0, 0, 0] },
      margin: { left: 0, right: 0 },
      tableWidth: 'auto',
      didDrawPage: (data) => { currentY = data.cursor?.y ?? currentY; }
    });
    return currentY;
  }

  private addFooterPDF(doc: jsPDF, pdfWidth: number, pageNumber: number, totalPages: number) {
    autoTable(doc, {
      startY: 742,
      body: [['Impreso: ' + this.getDate(), 'Usuario: ' + (this.user?.names || this.user?.mail || 'FPV'), 'Sistema: ' + this.getDomain(), 'Página ' + pageNumber + ' de ' + totalPages]],
      theme: 'plain',
      bodyStyles: { fontSize: 7, cellPadding: 0.3, textColor: [0, 0, 0] },
      tableWidth: 'auto',
      didDrawPage: (data) => {
        doc.setLineWidth(0.5);
        doc.line(35, 737, pdfWidth, 737);
      },
    });
  }


  exportBajaPDF() {
  const doc = new jsPDF('p', 'pt', 'letter');
  const pdfWidth = doc.internal.pageSize.getWidth() - 35;
  const entityName = this.getEntityName(this.data()?.entityCode || this.entity?.code);

  autoTable(doc, {
    html: '#hidden-baja-table',
    startY: 105,
    theme: 'grid', 
    useCss: true,
    tableWidth: 'auto',
    margin: { top: 110, bottom: 80, left: 35, right: 35 },
  });

  const totalPages = (doc as any).internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    this.addHeaderPDF(doc, entityName, 'SOLICITUD DE BAJA DE COBERTURA');
    this.addFooterPDF(doc, pdfWidth, i, totalPages);
  }

  // Generación del Preview
  const pdfBlob = doc.output('blob');
  const pdfUrl = URL.createObjectURL(pdfBlob);
  this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
  this.modalService.open(this.preview, { size: 'lg', backdrop: 'static' });
}

  previewBajaPDF() {
    this.exportBajaPDF();
  }

   submitBaja() {
    const payload = {
      partyUuid: this.data().uuid,
      processSlug: this.selectedProcess,
      entityCode: this.data().entityCode ?? this.entity?.code,
      referenceUuid: this.transferForm.get('referenceUuid')?.value || this.data().uuid,
      reason: this.transferForm.get('reason')?.value
    };
    this._confirmAndSendBaja(payload);
  }

  private _confirmAndSendBaja(payload: any) {
    Swal.fire({
      title: '¿Confirmar Solicitud?', text: 'Se enviará una solicitud de baja.',
      icon: 'question', showCancelButton: true, confirmButtonText: 'Sí, Enviar'
    }).then((result) => {
      if (result.isConfirmed) this._executeBajaRequest(payload);
    });
  }

  private _executeBajaRequest(payload: any) {
    this.partyOverviewService.createTransferRequest(payload).subscribe({
      next: () => {
        this.Toast.fire({ icon: 'success', title: 'Solicitud enviada correctamente' });
        this.checkPendingTransfer(this.data().uuid);
        this.showBajaForm.set(false);
      },
      error: (e) => Swal.fire('Error', e.error?.message ?? 'No se pudo enviar', 'error')
    });
  }

  


   findGroup(slug: string) {
    let name = this.group()?.find((item) => item.slug === slug);
    return name ? name.name : '';
  }

  openGlobalViewer(clickedId: string | number) {
    const allDocs = this._collectViewableDocs();
    if (allDocs.length > 0) {
      this.viewerItems = allDocs;
      this.activeViewerId = clickedId;
      this.isViewerOpen = true;
    } else {
      Swal.fire({ icon: 'info', title: 'Sin documentos', text: 'No hay documentos visualizables cargados.', confirmButtonText: 'Entendido' });
    }
  }

  private _collectViewableDocs(): any[] {
    const cats = this.documentsData?.categories ?? [];
    return cats
      .flatMap((cat: any) => cat.documents ?? [])
      .filter((d: any) => this._isImageDoc(d) || this._isPdfDoc(d))
      .map((d: any) => {
        const pdf = this._isPdfDoc(d);
        return {
          id: d.uuid ?? d.id,
          imageUrl: Global.url + d.filePath,
          title: d.docTypeName ?? d.fileName,
          status: 'success',
          mimeType: d.mimeType ?? (pdf ? 'application/pdf' : null),
          fileName: d.fileName ?? null,
          kind: pdf ? 'pdf' as const : 'image' as const
        };
      });
  }

  private _isPdfDoc(d: any): boolean {
    if (!d?.filePath) return false;
    const mime = String(d.mimeType ?? '').toLowerCase();
    const name = String(d.fileName ?? '').toLowerCase();
    const path = String(d.filePath ?? '').toLowerCase();
    return mime.includes('pdf') || name.endsWith('.pdf') || path.endsWith('.pdf');
  }

  private _isImageDoc(d: any): boolean {
    if (!d.filePath) return false;
    const imageByMime = d.mimeType?.toLowerCase().includes('image');
    const imageByName = !!d.fileName?.match(/\.(jpeg|jpg|gif|png|webp)$/i);
    const imageByPath = !!d.filePath?.match(/\.(jpeg|jpg|gif|png|webp)$/i);
    return imageByMime || imageByName || imageByPath;
  }

}
